import { selectCarVideoPreviewList, startLiveVideo, stopLiveVideo, convertVideoFormat, getRealtimeVideo, getPlayList, startHistoryVideo, stopHistoryVideo, downloadHistoryVideo } from "../../api/config/modules/VideoPreview";

const state = {
  selectCarVideoPreviewList: {},
  startLiveVideo: {},
  stopLiveVideo: {},
  convertVideoFormat: {},
  realtimeVideo: {},
  getPlayList: {},
  startHistoryVideo: {},
  stopHistoryVideo: {},
  downloadHistoryVideo: {}
};

const mutations = {
  SET_SELECTCARVIDEOPREVIEWLIST: (state, selectCarVideoPreviewList) => {
    state.selectCarVideoPreviewList = selectCarVideoPreviewList;
  },
  SET_STARTLIVEVIDEO: (state, startLiveVideo) => {
    state.startLiveVideo = startLiveVideo;
  },
  SET_STOPLIVEVIDEO: (state, stopLiveVideo) => {
    state.stopLiveVideo = stopLiveVideo;
  },
  SET_CONVERTVIDEOFORMAT: (state, convertVideoFormat) => {
    state.convertVideoFormat = convertVideoFormat;
  },
  SET_REALTIMEVIDEO: (state, realtimeVideo) => {
    state.realtimeVideo = realtimeVideo;
  },
  SET_GETPLAYLIST: (state, getPlayList) => {
    state.getPlayList = getPlayList;
  },
  SET_STARTHISTORYVIDEO: (state, startHistoryVideo) => {
    state.startHistoryVideo = startHistoryVideo;
  },
  SET_STOPHISTORYVIDEO: (state, stopHistoryVideo) => {
    state.stopHistoryVideo = stopHistoryVideo;
  },
  SET_DOWNLOADHISTORYVIDEO: (state, downloadHistoryVideo) => {
    state.downloadHistoryVideo = downloadHistoryVideo;
  },
};

const actions = {
  GET_SELECTCARVIDEOPREVIEWLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarVideoPreviewList(data).then((res) => {
        commit("SET_SELECTCARVIDEOPREVIEWLIST", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_STARTLIVEVIDEO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      startLiveVideo(data).then((res) => {
        commit("SET_STARTLIVEVIDEO", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_STOPLIVEVIDEO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      stopLiveVideo(data).then((res) => {
        commit("SET_STOPLIVEVIDEO", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CONVERTVIDEOFORMAT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      convertVideoFormat(data).then((res) => {
        commit("SET_CONVERTVIDEOFORMAT", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_REALTIMEVIDEO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getRealtimeVideo(data).then((res) => {
        commit("SET_REALTIMEVIDEO", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETPLAYLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getPlayList(data).then((res) => {
        commit("SET_GETPLAYLIST", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_STARTHISTORYVIDEO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      startHistoryVideo(data).then((res) => {
        commit("SET_STARTHISTORYVIDEO", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_STOPHISTORYVIDEO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      stopHistoryVideo(data).then((res) => {
        commit("SET_STOPHISTORYVIDEO", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DOWNLOADHISTORYVIDEO: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      downloadHistoryVideo(data).then((res) => {
        commit("SET_DOWNLOADHISTORYVIDEO", res);
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};